import * as Types from '../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type RejectProjectRequestMutationVariables = Types.Exact<{
  input: Types.RejectProjectRequestCommand;
}>;


export type RejectProjectRequestMutation = { __typename?: 'MutationModel', projectRequests: { __typename?: 'ProjectRequestMutationModel', reject: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', message: string, argumentName?: string | null }> } } };


export const RejectProjectRequestDocument = gql`
    mutation RejectProjectRequest($input: RejectProjectRequestCommand!) {
  projectRequests {
    reject(input: $input) {
      errors {
        message
        argumentName
      }
    }
  }
}
    `;
export type RejectProjectRequestMutationFn = Apollo.MutationFunction<RejectProjectRequestMutation, RejectProjectRequestMutationVariables>;

/**
 * __useRejectProjectRequestMutation__
 *
 * To run a mutation, you first call `useRejectProjectRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectProjectRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectProjectRequestMutation, { data, loading, error }] = useRejectProjectRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectProjectRequestMutation(baseOptions?: Apollo.MutationHookOptions<RejectProjectRequestMutation, RejectProjectRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectProjectRequestMutation, RejectProjectRequestMutationVariables>(RejectProjectRequestDocument, options);
      }
export type RejectProjectRequestMutationHookResult = ReturnType<typeof useRejectProjectRequestMutation>;
export type RejectProjectRequestMutationResult = Apollo.MutationResult<RejectProjectRequestMutation>;
export type RejectProjectRequestMutationOptions = Apollo.BaseMutationOptions<RejectProjectRequestMutation, RejectProjectRequestMutationVariables>;